export const USER = "MAP_USER";
export const JWT = "MAP_JWT";
export const JWT_DATA = "MAP_JWT_DATA";
export const COMPANY = "MAP_COMPANY";
export const PATH = "MAP_PATH";
export const MENU = "MAP_MENU";
export const LoginType = "MAP_LoginType";
export const Tenant = "MAP_Tenant";
export const Domain = "MAP_Domain";
